import type { CustomIconProps } from '../CustomIcon';

export const DocumentIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7Z'
        fill={color}
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13 2v7h7'
        stroke={secondaryColor}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
